if (window.matchMedia("(max-width:768px)").matches) {
 window.onscroll = function() {myFunction()}; 
 var toggle_bar = document.querySelector(".site-nav__thumb-menu"); 
  var product_bar = document.querySelector(".site-header"); 
  var sticky = product_bar.offsetTop+50;
  function myFunction() {
    if (window.pageYOffset > sticky) {
      product_bar.classList.add("site-header-sticky");
      toggle_bar.classList.add("toggle_bar-sticky");
    } 
    else {
      product_bar.classList.remove("site-header-sticky");
      toggle_bar.classList.remove("toggle_bar-sticky");
    }
  }
  }

 var offsetSticky = document.querySelector(".product-block__buy_buttons"); 
 if (offsetSticky != null) {
    window.onscroll = function() {productAddtocartSticky()};
console.log(offsetSticky);
 var cartSticky = document.querySelector(".product--single__sticky");  
 var offsetDeskSticky = document.querySelector(".product__Photos_puzzel"); 
  if (window.matchMedia("(max-width:768px)").matches) {
  var sticky = offsetSticky.offsetTop+offsetSticky.offsetHeight+200;  }
  else{ var sticky = offsetDeskSticky.offsetHeight - offsetDeskSticky.offsetTop - 200; }
  function productAddtocartSticky() {
    console.log(sticky);
    if (window.pageYOffset > sticky) {
      cartSticky.classList.add("addtocart-button-sticky"); 
    } 
    else {
      cartSticky.classList.remove("addtocart-button-sticky"); 
    }
    var stickyTitletHeight = document.querySelector(".product__sticky-title h3").offsetHeight;
   document.querySelector(".product__sticky-price p").style.height = stickyTitletHeight+"px";
   }
}

$(document).ready(function() {
  // =========country_code ======//  
// $.get("//ipinfo.io", function (response) {
//    console.log("IP: " + response.ip);
//    console.log("Country: " +response.country); 
//     if(response.country !== 'CA'){
//      // window.location.href = 'https://usa.bracelayer.com/';  
// 	}
//     }, "jsonp");
  
// ========country_code=======//  
  
$("ul.site-nav__deep a.site-nav__dropdown-link").hover(function(){
 var prodlistId = $(this).data('id');
if (prodlistId !== undefined){
  // $('.site-nav-product_list').removeClass('active');
  // $('#'+prodlistId).addClass('active');
  $(this).parents('.megaMenuLink-container').find('.site-nav-product_list').removeClass('active');
   $(this).parents('.megaMenuLink-container').find('#'+prodlistId).addClass('active');
}
});

  $(document).on('change','.product__sticky-quantity input[name="quantity"]',function(event) {
 event.preventDefault(); var thisQuantity = $(this).val(); 
  $('.product-block .product__quantity').find('input[type=number]').val(thisQuantity);
 }); 
   $(document).on('click','.product__sticky-cartbutton .prod__sticky-cartbutton',function() {
    $('.product-section button.add-to-cart').click();
  });

   $(document).on('click','nav.slide-nav__wrapper svg.icon-close',function() {
    $('.btn.site-nav__thumb-button').click();
  }); 

$(document).on('click','.blog-nav__item .blog_link--caret',function(event) {
  event.preventDefault(); var blogId = $(this).data('id');
 if ($(this).parents('.blog-nav__item').hasClass('active') || $('#'+blogId).hasClass('active')){
   $(this).parents('.blog-nav__item').removeClass('active');
   $('#'+blogId).slideUp().removeClass('active');
 } else {
    $('.blog-nav__item').removeClass('active');
    $('.blog-nav__dropdown').slideUp().removeClass('active');
    $(this).parents('.blog-nav__item').addClass('active');
    $('#'+blogId).slideDown().addClass('active');
 }
});
  $(document).on('change', '#ArticleTagFilter', function(event){
  var geturl = $(this).val();
  //alert(geturl);
   if (geturl){ 
    window.location = geturl; 
   }
   return false;
});

$(document).on('click','.product-section button.add-to-cart',function(evt) {  
   $('.product-section fieldset.variant-input-wrap').each(function() {  
    if ($(this).data('handle') == 'size'){
     var inputCheked = false ; 
    $('fieldset.variant-input-wrap[data-handle="size"]').find(".variant-input").each(function() { 
     if ($(this).find('[data-variant-input]').is(':checked') == true) { 
      inputCheked = true ;   
      }   
     }); 
      if (inputCheked == true){
         evt.preventDefault = false; 
         $('.variant-wrapper .label-input--size').hide(); 
      } else { 
        evt.preventDefault();
        $('.variant-wrapper .label-input--size').show(); 
        $('html, body').animate({
        scrollTop: $(".product-single__meta").offset().top
       }, 500);
      }
    }
 });

 });  
  
});



$(document).ready(function(){
 $(document).on('click', '.recommendation-modal__form button.recommendation-modal__button', function(e){    
    //e.preventDefault();    
     if($(document).find('select.recommendation-modal__selector--flag').length){      
      var flagVal = $('select.recommendation-modal__selector--flag :selected').val();
      console.log('flagVal');
      if(flagVal == 'US'){
          e.preventDefault();  
         window.location.href = "https://bracelayer.com";
      } 
    }else if($(document).find('input[name="country_code"]').length){      
      var country_code = $('input[name="country_code"]').val();
        console.log('country_code'); 
      if(country_code == 'US'){
        e.preventDefault();  
         window.location.href = "https://bracelayer.com";
      }
    } else{}
  });
});